import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal, Result } from 'antd';
import { BackendAPI } from '../axios';
import { Outlet, useNavigate } from 'react-router-dom';
import UserHeader from './AuthComponents/UserHeader';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/userSlice';

const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes

function PrivateLayout() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshToken, setRefreshToken] = useState<string>('');
  const [isOnClickSlider, setOnclickSlider] = useState(false);
  const dispatch=useDispatch();
  //const refreshToken=null;

  const navigate = useNavigate();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  
      const logoutUser = async () => {
        try {
            const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

            if (response.status === 200) {
                localStorage.removeItem("authToken");
                localStorage.setItem("sessionTimeoutMessege", "true");
                navigate("/");
            }
        } catch (error) {
        }
    };
  
   const resetTimer = () => {

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      logoutUser();
    }, SESSION_TIMEOUT);
  };

    useEffect(() => {

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click"
    ];

    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // start timer on load
   
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);

      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };

  }, []);

    
    const getRefreshToken = async () => {
  try {
    const response = await BackendAPI.get("/user/refresh-token", {
      withCredentials: true,
    });

    setRefreshToken(response.data); // only if needed elsewhere

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
const getUserInfo = async (token: string) => {
  const header = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await BackendAPI.get("/user/info", header);

    const data = response.data;

    dispatch(
      setUser({
        regId: data.regId,
        username: data.username,
        registrationNo: data.registartion_no,
        organizationName: data.organizationName,
        organizationType: data.organizationType,
        city: data.city,
        address: data.address,
        phone: data.phone,
        pincode: data.pincode,
        projectDescription: data.project_description,
        projectPurpose: data.project_purpose,
        quarterlyTransactionCount: data.quarterly_transaction_count,
        serviceType: data.service_type,
        sacode: data.sa_code,
        dept: data.dept,
        ministry: data.ministry,
        set_password_flag: data.set_password_flag,
        aua_kua_code: data.aua_kua_code,
        aua_kua_code_prod: data.aua_kua_code_prod,
      })
    );
  } catch (error) {
    console.error(error);
  }
};
    
    useEffect(() => {
  const initialize = async () => {
    const token = await getRefreshToken();

    if (token) {
      await getUserInfo(token);
    }
  };

  initialize();
}, []);
  
useEffect(() => {

  const sessionTimeoutMessege = localStorage.getItem("sessionTimeoutMessege");

  if (sessionTimeoutMessege === "true") {

    toast.error(
      "Your session has timed out. Please log in again to continue.",
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true
      }
    );

    localStorage.setItem("sessionTimeoutMessege", "false");
  }

}, []);
  // const token = localStorage.getItem("authToken");

  const backtoLogin = () => {
    setIsModalOpen(false);
    window.location.href = "/"; // Navigate to the login/home page
  };

    if (!refreshToken) {
    // Show the modal if the user is unauthorized
  return (
      <Modal
        centered
        open={true}
        footer={null}
        maskClosable={true}
        closable={false}
      >
        <Result
          style={{ padding: '10px' }}
          status="403"
          title={<span style={{ color: 'red', fontSize: '2rem' }}>403</span>}
          subTitle={
            <span style={{ color: 'blue', fontSize: '1rem' }}>
              Sorry, you are not authorized to access this page.
            </span>
          }
        />
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={backtoLogin}>
            Back to Home Page
          </Button>
        </div>
      </Modal>
  )
}
return (
    <div>
      {/* You can wrap this with a layout (e.g. sidebar/navbar) */}
      <div>
                        <UserHeader />
                    </div>
      <Outlet />
    </div>
  );
}

export default PrivateLayout;